// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1R8Tw","dragIcon":"SortableItem_dragIcon__3_qlE","disabled":"SortableItem_disabled__21Oj_"};